import { render, staticRenderFns } from "./ListaArvores.vue?vue&type=template&id=281fb18f"
import script from "./ListaArvores.vue?vue&type=script&lang=js"
export * from "./ListaArvores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports